import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const analyzeSalesCall = (saleReviewId, payload, speaker, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'ANALYZING_SALES_CALL' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/cs/sale-reviews/${saleReviewId}/analyse`,
            payload,
            {
              params: {
                'request-id': reqId,
                speaker: speaker,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'ANALYZING_SALES_CALL_DONE',
              payload: {
                response: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data?.analysis);
            }
          } else {
            dispatch({
              type: 'ANALYZING_SALES_CALL_FAILED',
              payload: `Failed to analyse the call`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'ANALYZING_SALES_CALL_FAILED',
            payload: `Failed to analyse the call`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'ANALYZING_SALES_CALL_FAILED',
        payload: `Failed to analyse the call`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default analyzeSalesCall;
